import React from "react";
import { productos } from "./data";
import CardProducto from "./CardProducto";

const Productos: React.FC = () => (
  <div>
       {" "}
    {productos.map((producto) => (
      <CardProducto key={producto.id} producto={producto} />
    ))}
     {" "}
  </div>
);

export default Productos;
